import React, { useState, useEffect } from 'react';

const waistOptions = [
  `28"`, `30"`, `32"`, `34"`, `36"`, `38"`, `40"`, `42"`, `44"`, `46"`
];

const StepWaist = ({ data, setData, onNext, onPrev }) => {
  const [customInches, setCustomInches] = useState('');

  const handleSelect = (waist) => {
    setData(prev => ({
      ...prev,
      waist
    }));
    setCustomInches('');
  };

  const handleCustomChange = () => {
    if (customInches) {
      const formatted = `${customInches}"`;
      setData(prev => ({
        ...prev,
        waist: formatted
      }));
    }
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      waist: null
    }));
    onNext();
  };

  // ✅ Auto-fill custom inches if waist is not in predefined options
  useEffect(() => {
    const isCustom = data.waist && !waistOptions.includes(data.waist);
    const match = data.waist?.match(/^(\d+)"$/);
    if (isCustom && match) {
      setCustomInches(match[1]);
    }
  }, [data.waist]);

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="waist-size-container">
              <h3 className="waist-size-title">What is your waist size?</h3>

              <div className="waist-size-grid selection-grid">
                {waistOptions.map((option) => (
                  <button
                    key={option}
                    className={`selection-btn ${data.waist === option ? 'active' : ''}`}
                    onClick={() => handleSelect(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>

              <div className="custom-height mt-3">
                <label>Something else:</label>
                <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                  <input
                    type="text"
                    placeholder="in"
                    value={customInches}
                    onChange={(e) => setCustomInches(e.target.value)}
                    onBlur={handleCustomChange}
                  />
                </div>
              </div>

              <button className="skip-btn mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="nav-buttons mt-4">
                <button className="selection-prev-btn" onClick={onPrev}>
                  Prev
                </button>
                <button
                  className="selection-next-btn"
                  onClick={onNext}
                  disabled={!data.waist}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepWaist;
